import React from 'react';
import { Stack } from '@mui/material';

import {
  OptimizationLaborTerm,
  setLaborTermEnabled,
  setLaborTermValue,
} from '../../../../store/slices/optimizationSettingsSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { CostTermRow } from './CostTermRow';

const LABOR_TERMS: readonly { term: OptimizationLaborTerm; label: string; soon?: boolean }[] = [
  { term: 'perCut', label: 'Per cut' },
  { term: 'perMember', label: 'Per member' },
  { term: 'perUniqueMember', label: 'Per unique member' },
  { term: 'perJoint', label: 'Per joint' },
  { term: 'perSplice', label: 'Per splice' },
  { term: 'perBoardFoot', label: 'Per board foot' },
  { term: 'perPlate', label: 'Per plate pair' },
  { term: 'perUniquePlate', label: 'Per unique plate', soon: true },
  { term: 'twoPlyLabor', label: 'Two-ply assembly' },
  { term: 'threePlyLabor', label: 'Three-ply assembly' },
];

interface Props {
  readonly disabled: boolean;
}

export function LaborFactors({ disabled }: Props) {
  const dispatch = useAppDispatch();
  const labor = useAppSelector((state) => state.optimizationSettings.labor);

  return (
    <Stack spacing={1}>
      {LABOR_TERMS.map(({ term, label, soon }) => (
        <CostTermRow
          key={term}
          label={label}
          soon={soon}
          disabled={disabled}
          enabled={labor[term].enabled}
          value={labor[term].value}
          onToggle={(enabled) => dispatch(setLaborTermEnabled({ term, enabled }))}
          onValueChange={(value) => dispatch(setLaborTermValue({ term, value }))}
          valueAriaLabel={`${label} cost`}
        />
      ))}
    </Stack>
  );
}
